import { useCallback, useEffect, useState } from "react";
import { useRouter } from "next/router";

import HeroSection from "../../Components/HeroSection";
import HowItWorksSection from "../../Components/HowItWorksSection";
import OneOnOneYogaForm from "../../Components/OneOnOneYogaForm";
import WhatMakesShyftBootCampUniqueSection from "../../Components/WhatMakesShyftBootCampUniqueSection";
import CallbackSection from "../../Components/CallbackSection";
import Testimonials from "@/components/Organisms/TestimonialsV2";
import RealWorldTransformation from "../../Components/RealWorldTransformation";
import AppBannerSection from "../../Components/AppBannerSection";
import BootcampListing from "../../Components/BootcampListing";
import AllPackagesSection from "../../Components/AllPackagesSection";
import ReadyToBuildSection from "../../Components/ReadyToBuildSection";
import FaqSection from "@/components/Molecules/FaqSection";
import OneOnOneYogaFloatingBanner from "../../Components/OneOnOneYogaFloatingBanner";
import BookTrialClassModal from "../../Components/BookTrialClassModal";
import CustomIntercomButton from "../../Components/CustomIntercomButton";
import SymptomsAndConditionsSection from "../../Components/SymptomsAndConditionsSection";
import OneOnOneYogaModal from "../../Components/OneOnOneYogaModal";
import TrialCallbackModal from "../../Components/OneOnOneYogaForm/TrialCallbackModal";

import CertifiedInstructors from "../../Components/Shared/CertifiedInstructors";

import { classNameGenerator, timezone } from "@/utils";

import { useAppDispatch, useAppSelector } from "@/hooks";

import * as actions from "@/redux/BootCampReducer";

import styles from "./OneOnOneYogaPage.module.scss";

interface OneOnOneYogaPageProps {}

const OneOnOneYogaPage: React.FC<OneOnOneYogaPageProps> = () => {
  const router = useRouter();
  const dispatch = useAppDispatch();

  const cls = classNameGenerator(styles);

  const { data, showOneOnOneTrialCallbackModal } = useAppSelector(
    (state) => state.bootCamp
  );

  const { testimonies } = data?.testimonials || {};
  const faqs = data?.faqs || {};

  const [showCallbackModal, setShowCallbackModal] = useState(false);

  const { query } = router;

  let pageSlug =
    typeof query?.slug === "string" ? query?.slug : query?.slug?.[0] || "";

  const isTrialPage = data?.subPageType === "ONE_ON_ONE_YOGA_TRIAL" ? true : false

  useEffect(() => {
    if (pageSlug === "1-on-1-yoga-trial") {
      dispatch(actions.getOneOnOneYogaSlots({ timezone }));
    }
  }, [dispatch, pageSlug]);

  useEffect(() => {
    if (pageSlug === "online-yoga-class") {
      dispatch(actions.getOneOnOneYogaSlots({ timezone }));
    }
  }, [dispatch, pageSlug]);

  const setShowOneOnOneTrialCallbackModal = useCallback(
    (data: boolean) =>
      dispatch(actions.setShowOneOnOneTrialCallbackModal(data)),
    [dispatch]
  );

  return (
    <div className={cls("oneOnOneYogaPage")}>
      <HeroSection />
      <HowItWorksSection>
        <OneOnOneYogaForm />
      </HowItWorksSection>
      <SymptomsAndConditionsSection
        titleDesktop={isTrialPage ? 'Our classes are customized for' : 'Your goal class can be customized for the following concerns'}
        titleMobile={isTrialPage ? 'Our classes are customized for' : 'Your goal class can be customized for the following concerns'}
        isTrialPage={isTrialPage}
      />
      <WhatMakesShyftBootCampUniqueSection />
      <Testimonials testimonies={testimonies} />
      <CallbackSection titleText={isTrialPage ? "Can't find the slot you want?" : ""} descriptionText={isTrialPage ? "Our team can help. Request a call back.": ""}/>
      <RealWorldTransformation />
      <AllPackagesSection />
      {!isTrialPage && <div className={cls("certifiedInstructors")}>
        <CertifiedInstructors />
      </div>}
      <AppBannerSection />
      {isTrialPage && <div className={cls("certifiedInstructors")}>
        <CertifiedInstructors />
      </div>}
      <BootcampListing />
      <FaqSection {...faqs} />
      <ReadyToBuildSection setShowModal={setShowCallbackModal} />
      <OneOnOneYogaFloatingBanner />
      <BookTrialClassModal />
      {/* <CustomIntercomButton bottom="75px" /> */}
      <OneOnOneYogaModal
        showModal={showCallbackModal}
        setShowModal={setShowCallbackModal}
      />
      <TrialCallbackModal
        showModal={showOneOnOneTrialCallbackModal}
        setShowModal={setShowOneOnOneTrialCallbackModal}
      />
    </div>
  );
};

export default OneOnOneYogaPage;
